import useMediaQuery from '@mui/material/useMediaQuery';
import useTrialBanner from '../trial-banner/useTrialBanner';
import { useDemoData } from './demoData';

/** Mesmo corte das versões curtas das faixas (TrialBanner.module.css, DemoDataBanner.module.css). */
export const PHONE_QUERY = '(max-width: 600px)';

/**
 * No celular, com a faixa do teste e a dos exemplos ao mesmo tempo, as duas viram
 * uma linha só ("30 dias · com exemplos"): TrialBanner some e DemoDataBanner
 * desenha a faixa única. trial: o estado de useTrialBanner, para os textos e a cor.
 */
export default function useTrialDemoCompact() {
  const isPhone = useMediaQuery(PHONE_QUERY);
  const trial = useTrialBanner();
  const { removable } = useDemoData();
  return { compact: isPhone && trial.visible && removable, trial };
}
